import { createTheme } from '@mui/material/styles';

// import { createLightTheme, createDarkTheme } from '@dndbeyond/ddb-theme';
type PaletteOpt = 'light' | 'dark';

export const getTheme = (lightOrDark: PaletteOpt = 'light', primary = '#c53131') => {
    // TODO: Use this when the Theme is ready

    // if ((lightOrDark = 'light')) {
    //     return createLightTheme();
    // } else {
    //     return createDarkTheme();
    // }

    return createTheme({
        palette: {
            mode: lightOrDark,
            background:
                lightOrDark === 'light'
                    ? { default: '#fefefe', paper: '#fefefe' }
                    : { default: '#10161a', paper: '#10161a' },
            primary: { main: primary },
        },
        zIndex: {
            modal: 99999,
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: 'Roboto Condensed',
                        fontSize: '13px',
                    },
                    outlinedPrimary: {
                        margin: '0 10px',
                        color: lightOrDark === 'light' ? primary : '#ffffff',
                        border: `1px solid ${primary}`,
                        '&:focus, &:active, &:hover': {
                            boxShadow: `0 0 2px ${primary}`,
                            backgroundColor: `${primary}33`,
                        },
                    },
                    containedPrimary: {
                        margin: '0 10px',
                    },
                },
            },
            MuiTabs: {
                styleOverrides: {
                    root: {
                        borderBottom: `1px solid ${primary}`,
                        margin: '0 0 16px',
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        fontFamily: 'Roboto Condensed',
                        fontWeight: 'bold',
                        fontSize: 18,
                        letterSpacing: 0,
                        textTransform: 'none',
                    },
                    textColorPrimary: {
                        color: '#838383',
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    body1: {
                        fontSize: 13,
                    },
                    body2: {
                        fontFamily: 'Roboto',
                        fontSize: 13,
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        color: '#838383',
                    },
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        color: lightOrDark === 'light' ? '#000000' : '#ffffff',
                    },
                },
            },
            MuiDialogContentText: {
                styleOverrides: {
                    root: {
                        color: lightOrDark === 'light' ? '#000000' : '#ffffff',
                    },
                },
            },
        },
    });
};
